import axios from 'axios';

// const URL = 'http://localhost:4000'
const URL = process.env.REACT_APP_BASE_URL || 'https://roshi-chat.herokuapp.com' 

axios.defaults.baseURL = URL;

// export const fetchFeeds = async (id, role, archived, s) => {
//     try {
//         let threads = await axios.get(`${apiUrl}/feeds/all`)
//         return threads.data
//     } catch (error) {
//         console.log(error)
//         return []
//     }
// }

export const fetchFeed = async (id, page = 0) => {
    let res = await axios.get(`/coach/post/feed`, {
        params: {
            userId: id,
            page
        }
    })
    return res.data;
}